import { SHOW_REFERRALS } from '../Actions/types'
import { HIDE_REFERRALS } from '../Actions/types'

const initialState = {
    showReferrals: false
}

export default function (state = initialState, action) {
    switch(action.type) {
        case SHOW_REFERRALS: 
      
            return {
             ...state,
             showReferrals: action.payload
            };
        case HIDE_REFERRALS: 
            return{
                ...state,
                showReferrals: action.payload
            }
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/showReferralsReducer.js